import { useBillingUser } from '@/features/subscription/billing/billing-user-context'
import type { SubscriptionType } from 'api/dist/shared-types/shared-billing-types'
import { useCallback, useMemo } from 'react'

export const useBilling = () => {
    const billingUser = useBillingUser()

    const currentActiveSubscription = useMemo(() => {
        return billingUser?.currentActiveSubscription
    }, [billingUser])

    const getIsSubscriptionType = useCallback(
        (subscriptionTypes: SubscriptionType[]) => {
            if (!currentActiveSubscription) return false

            return subscriptionTypes.includes(currentActiveSubscription.subscriptionType as SubscriptionType)
        },
        [currentActiveSubscription]
    )

    return { currentActiveSubscription, getIsSubscriptionType }
}
